import { types, actions } from './requests'
export const GETWORKLISTFORDATE_TYPES = {
    ...types('GETWORKLISTFORDATE'),
}
export const GETWORKLISTFORDATE_ACTIONS = {
    ...actions('GETWORKLISTFORDATE'),
}
